<template>
  <div class="left-index">
    <div id="left">
      <!-- 头部 -->
      <div class="left-top-type">
        <div class="left-date">
          <div class="date">
            <div class="date-div" v-if="currentTime">
              <img class="icon19" src="../assets/icon-19.png" />
              <div>{{ currentTime }}</div>
            </div>
          </div>
        </div>
        <div class="center">
          <div class="center-logo">
            <div class="padd">
              <img
                class="icon8"
                src="../assets/icon-08.png"
                alt=""
                v-if="typeName.length < 10"
              />
              <span
                class="center-text"
                v-if="typeName"
                :class="typeName.length >= 12 ? 'typeNameClass' : ''"
              >
                {{ typeName }}大屏
              </span>
              <span class="center-text" v-else> 德鑫互联智慧大屏 </span>
              <img
                class="icon9"
                src="../assets/icon-09.png"
                alt=""
                v-if="typeName.length < 10"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <!-- 最左边 -->
        <div class="leftmost">
          <!-- 平台维修量 -->
          <div id="platformRepairQuantity">
            <div class="text-title">
              <div class="spot"></div>
              <div class="text">平台维修量</div>
            </div>
            <div class="eliminate-float"></div>
            <div class="dynamicDigital" @click="getShow('repair', 'allRepair')">
              <div class="float-left">
                <dynamic-digital :realTimeNumber="allTotal"></dynamic-digital>
              </div>
              <div class="text-color float-left text-single">单</div>
            </div>
            <div class="eliminate-float"></div>
            <div class="wait">
              <div
                class="wait-close-single float-left"
                @click="getShow('repair', 'cost')"
              >
                <div class="imgIcon01">
                  <img class="img-icon01" src="../assets/icon-01.png" alt="" />
                </div>
                <div class="wait-text">
                  <div class="text-red">{{ costTotal }}</div>
                  <div class="text-color text14">等待关单</div>
                </div>
              </div>
              <div
                class="float-left m-l-35"
                @click="getShow('repair', 'confirmed')"
              >
                <div class="imgIcon01">
                  <img class="img-icon01" src="../assets/icon-02.png" alt="" />
                </div>
                <div class="wait-text">
                  <div class="text-LG">{{ confirmedTotal }}</div>
                  <div class="text-color text14">等待验收</div>
                </div>
                <div class="eliminate-float"></div>
              </div>
            </div>
          </div>
          <div class="eliminate-float"></div>
          <!-- 平台设备完好率 -->
          <div id="praise" @click="getShow('equPage', 'allEquStatus')">
            <div class="text-title">
              <div class="spot"></div>
              <div class="text">平台设备完好率</div>
            </div>
            <div class="eliminate-float"></div>
            <div class="equ-praise">
              <circular-progress-bar
                :listData="intactRateList"
              ></circular-progress-bar>
            </div>
          </div>
          <!-- 医院维修排行 -->
          <div id="repairRanking">
            <div
              class="text-title"
              style="cursor: pointer"
              @click="getShow('repair', 'allRepair')"
            >
              <div class="spot"></div>
              <div class="text">医院维修量排行</div>
            </div>
            <div class="eliminate-float"></div>
            <div class="histogram">
              <div
                id="histogram"
                :style="{ width: '409px', height: '280px' }"
              ></div>
            </div>
          </div>
        </div>
        <!-- 品类设备 -->
        <div class="equ-number">
          <div>
            <flip-cards
              :flip="mangementTypeTotalDTO"
              :back="categoryEquTotal"
              @getType="getType"
            ></flip-cards>
          </div>
        </div>
        <!-- 中心 -->
        <div class="center-equ-total">
          <div class="equ-total">
            <div class="bg-equ-total"></div>
            <div class="radar"></div>
            <div class="circle3">
              <div class="total" @click="getShow('equPage', 'allEquStatus')">
                <div class="total-text">
                  {{ equMaintenanceTotalDTO.equTotal*9 ||0}}
                </div>
                <div class="total-title">管理设备总数(台)</div>
              </div>
              <div class="bgDownH">
                <div class="bgDown"></div>
              </div>
              <div class="processing">
                <div class="float-left" @click="getShow('repair', 'noSuccess')">
                  <div class="ls">
                    {{ engineerRankingDto.repairNum || 0 }}<span>台</span>
                  </div>
                  <div class="text14-color">正在维修</div>
                </div>
                <div
                  class="float-left ml43"
                  @click="getShow('findMaintainExecutingPage')"
                >
                  <div class="ls">
                    {{ engineerRankingDto.maintainNum }}<span>台</span>
                  </div>
                  <div class="text14-color">正在保养</div>
                </div>
                <div
                  class="float-left ml43"
                  @click="getShow('findInspectExecutingPage')"
                >
                  <div class="ls">
                    {{ engineerRankingDto.inspectNum }}<span>台</span>
                  </div>
                  <div class="text14-color">正在巡检</div>
                </div>
              </div>
            </div>
          </div>
          <div class="number-users-ico">
            <div class="us-bg-img">
              <div class="bg-icon10">
                <img class="icon10" src="../assets/icon-10.png" alt="" />
              </div>
              <img class="icon14" src="../assets/icon-14.png" alt="" />
            </div>
            <div class="number-users">
              <div class="users-text">{{ users.total }}</div>
              <div class="text14-color">用户数量 (人)</div>
            </div>
          </div>
          <div class="repair-hours">
            <div class="repair-hours-img">
              <div class="bg-icon17">
                <img class="icon17" src="../assets/icon-03.png" alt="" />
              </div>
              <img class="icon15" src="../assets/icon-15.png" alt="" />
            </div>
            <div class="repair-hours-text">
              <div class="users-text mb10">{{ repairAvgDuration }}h</div>
              <div class="text14-color mb10">平均维修工时</div>
              <div class="text14 response">
                <i class="lcon"></i>
                <span class="">平均响应时间：</span>
                <!-- {{ responseAvgDuration }} -->
                <span>1.09h</span>
              </div>
            </div>
          </div>
          <div class="full-insurance-equ">
            <div class="full-bg-img">
              <div class="bg-icon12">
                <img class="icon12" src="../assets/icon-12.png" alt="" />
              </div>
              <img class="icon16" src="../assets/icon-16.png" alt="" />
            </div>
            <!--  @click="getShow('equPage','maintainWarranty')" -->
            <div class="full-insurance">
              <div class="users-text">
                {{ equMaintenanceTotalDTO.fullTotal*9 }}
              </div>
              <div class="text14-color mb15">全保设备(台)</div>
              <div>
                <maintenance-type
                  v-if="maintenanceTypeList && maintenanceTypeList.length"
                  :listData="maintenanceTypeList"
                  @getMaintenance="getMaintenance"
                ></maintenance-type>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- center-logo -->
    </div>
    <!-- 中间详情弹窗 -->
    <all-details
      id="middle"
      class="all-details"
      v-if="showData.isShow"
      :dataList="showData.dataList"
      :hospitalId="showData.hospitalId"
      :departId="showData.departId"
      :type="showData.type"
      :currentStatus="showData.currentStatus"
      :date="showData.date"
      :pages="pages"
      :hospitalList="hospitalList"
      :managementTypeList="managementTypeList"
      :allEnumsData="allEnumsData"
	    :isDepartment="isDepartment"
      :departList="departList"
      @Hide="Hide"
      @getPages="getPages"
      @getSizePages="getSizePages"
      @dateParam="getHospitalPagesDate"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    ></all-details>
    <!-- 左边弹窗 -->
    <let-popup @rightQuery="rightQuery" :hospitalList="hospitalList" :largeScreenType='1'></let-popup>
  </div>
</template>

<script>
import util from '@/utils/util.js'
import allStatus from '@/utils/all-status.js'
import dynamicDigital from '@/components/dynamicDigital'
import circularProgressBar from '@/components/circular-progress-bar'
import flipCards from '@/components/flip_cards'
import letPopup from '@/components/letPopup'
import allDetails from '@/components/all-details'
import maintenanceType from '@/components/maintenance-type' // 维修类型滚动

import { SocketInit } from '@/utils/websocket/socketUtil.js'

export default {
  mixins: [SocketInit], // 混入文件
  components: {
    dynamicDigital,
    circularProgressBar,
    letPopup,
    flipCards,
    allDetails,
    maintenanceType
  },
  data () {
    return {
      util,
      allStatus,
      // 维修
      allTotal: 0,
      confirmedTotal: 0, // 验收
      costTotal: 0, // 关单
      chartInstance: null,
      barSeries: null, // 柱状图X轴医院维修量
      barXAxis: null, // 柱状图X轴医院名称
      barSeriesList: null,
      responseAvgDuration: 0,
      repairAvgDuration: 0,
      // 设备
      equMaintenanceTotalDTO: {
        equTotal: '',
        fullTotal: '' // 全保
      },
      maintenanceList: [], // 维修类型字符串数组
      maintenanceTypeList: [], // 维修类型（没有全保设备、设备总数）
      intactRate: {
        // 完好
        allEqu: 0,
        cREqu: 0,
        cTEqu: 0,
        dRRepairEqu: 0,
        dSARepairEqu: 0,
        mRRepairEqu: 0,
        mRIEqu: 0,
        firstAidTotal: 0,
        implantTotal: 0,
        largeMedicalEquTotal: 0,
        lifeSupportTotal: 0,
        radiationTotal: 0,
        sterilizeTotal: 0
      },
      intactRateList: [],
      // 类型设备（台）
      mangementTypeTotalDTO: {
        // 卡片正面
        firstAidTotal: '0',
        implantTotal: '0',
        largeMedicalEquTotal: '0',
        lifeSupportTotal: '0',
        radiationTotal: '0',
        sterilizeTotal: '0'
      },
      categoryEquTotal: {
        // 卡片反面
        cRTotal: '0',
        cTTotal: '0',
        dRTotal: '0',
        dSATotal: '0',
        mRTotal: '0',
        mRITotal: '0'
      },
      // 用户
      users: {
        socketType: '',
        total: ''
      },
      // 统计
      engineerRankingDto: {
        inspectNum: 0,
        maintainNum: 0,
        repairNum: 0
      },
      startValue: 0,
      endValue: 5,
      timdId: null, // 定时器
      timingDate: null, // 当前时间定时器
      currentTime: '', // 当前时间
      year: '',
      month: '',
      typeName: '', // 中间更改医院的标题名称
      hospitalList: [], // 医院列表
      showData: {
        // 传给组件的参数
        isShow: false,
        type: '',
        dataList: [], // 点击要展示的数据
        hospitalId: null,
        departId: null,
        currentStatus: null,
        date: ''
      },
      pages: {
        pages: 0,
        current: 0,
        size: 0,
        total: 0
      },
      managementTypeList: [], // 所有医院管理类型
      hospitalId: null,
      loading: true,
      allEnumsData: null, // 枚举
      EquMaintainStatusList: null, // 保养状态枚举
      MeasureTypeList: null, // 计量状态
      EquMaintainWarrantyStatusList: null, // 保修状态
      EquInspectStatusList: null,
	    isDepartment: false, // 是否是科室
      departList: []
    }
  },
  created () {
    this.timingDate = setInterval(() => {
      /* 时间 */
      this.currentTime = this.util.formatDate()
    }, 1000)
  },
  mounted () {
    this.drawLine()
    this.initSocket(this.$Pane.leftPane.id)

    // 取当前年的开始/结束时间
    let currentYear = new Date()
    let startYear = this.util.startYear(currentYear)
    let endYear = this.util.endYear(currentYear)
    this.lineSearchParam.startTime = startYear
    this.lineSearchParam.endTime = endYear
  },
  beforeMount () {
    this.startInterval()
  },
  destroyed () {
    clearInterval(this.timdId)
    clearInterval(this.timingDate)
  },
  watch: {
    'showData.currentStatus' () {
      //  allDetails组件重置
      this.showData.isShow = false
      this.$nextTick(() => {
        this.showData.isShow = true
      })
    }
  },
  methods: {
    // 接收共享信息
    acceptSharingData (info) {
      let message = JSON.parse(info.webSocketShareDto.message)
      console.log('接收右屏共享信息', message)
      if (message.type) {
        this.getShow(message.type, message.status)
      }
    },
    // 筛选查询
    rightQuery (e) {
      console.log('查询年月', e)
      this.showData.isShow = false
      this.searchParam.startTime = e.startTime // 开始时间 2020
      this.searchParam.endTime = e.endTime // 结束时间
      this.searchParam.year = e.year // 查询年份(必要)
      this.searchParam.hospitalId = e.hospitalId
      this.searchParam.getEquPageParam.hospitalId = e.hospitalId
      this.getHospitalManagementTypeList() // 医院管理类型

      console.log('右边折纸图参数', this.lineSearchParam)
      // 发起共享信息
      // 并接文字提示
      let message = {}
      let year = ''
      let month = ''
      let HName = ''
      if (e.type === 'year') {
        year = this.searchParam.year + '年'
      }
      if (e.type === 'month') {
        month =
          this.searchParam.year +
          '年' +
          this.util.currentMonth(this.searchParam.startTime) +
          '月'
      }
      if (e.hospitalId) {
        HName = e.hospitalName
      }
      message = {
        // 此变量结构可随意更改
        type: 'updateTips',
        dateType: '',
        typeName: HName + year + month,
        startTime: null,
        endTime: null
      }
      if (e.type === 'month' || e.type === 'datetimerange') {
        message.dateType = 'day'
      } else {
        message.dateType = 'month'
      }
      if (e.startTime && e.endTime) {
        message.startTime = e.startTime
        message.endTime = e.endTime
      }
      let name = message.typeName
      this.typeName = name
      if (this.searchParam.hospitalId) {
        // 是否查医院排行
        this.isHospital = false
      } else {
        this.isHospital = true
      }

      // 右边折纸图参数
      if (e.startTime && e.endTime) {
        this.lineSearchParam.startTime = e.startTime
        this.lineSearchParam.endTime = e.endTime
        this.lineSearchParam.hospitalId = e.hospitalId
        this.lineSearchParam.dateType = message.dateType
      } else {
        // 取当前年的开始/结束时间
        let currentYear = new Date()
        let startYear = this.util.startYear(currentYear)
        let endYear = this.util.endYear(currentYear)
        this.lineSearchParam.startTime = startYear
        this.lineSearchParam.endTime = endYear
        this.lineSearchParam.dateType = message.dateType
      }
      console.log('查询年月参数', this.searchParam)
      console.log('messagem', message)
      this.shareInformation(message, this.$Pane.leftPane.send) // 发起共享信息,共享信息客户端的二级ID
      if (this.searchParam.hospitalId) {
        this.getDepartmentList() // 查询科室列表
      }
      this.changeParam()
    },
    getShow (type, data = null) {
      // 判定选择了那个模块\
      console.log('取到getShow', type, data)
      this.showData.type = null
      this.pages.pages = 1
      this.pages.current = 0
      this.pages.size = 10
      this.showData.dataList = []
      this.showData.hospitalId = null
      this.showData.currentStatus = null
      this.showData.departId = null
      // 组装参数
      let dataParam = {
        hospitalId: null,
        paramStatus: null, // 父子组件之间用的状态
        type: null,
        status: null, // 提交给接口的状态
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        departId: null
      }

      // 所有参数为null
      // 下面会重新赋值
      // 维修
      this.searchParam.pageRepairParam.page = 1
      this.searchParam.pageRepairParam.hospitalId = null
      this.searchParam.pageRepairParam.status = null
      this.searchParam.pageRepairParam.reportEndTime = null
      this.searchParam.pageRepairParam.reportStartTime = null
      // 设备
      this.searchParam.getEquPageParam.page = 1
      this.searchParam.getEquPageParam.hospitalId = null
      this.searchParam.getEquPageParam.typeId = null
      this.searchParam.getEquPageParam.medicalClassificationCode = null
      // 计量
      this.searchParam.getEquPageParam.measureType = null
      //  设备价值
      this.searchParam.getEquPageParam.purchaseMoneySearch = null
      this.searchParam.getEquPageParam.warrantyStatus = null
      // 保养
      this.searchParam.findExecutingMaintainPageParam.page = 1
      this.searchParam.findExecutingMaintainPageParam.hospitalId = null
      this.searchParam.findExecutingMaintainPageParam.dataStatus = null
      // 巡检
      this.searchParam.findExecutingInspectPageParam.page = 1
      this.searchParam.findExecutingInspectPageParam.hospitalId = null
      this.searchParam.findExecutingInspectPageParam.dataStatus = null
      //  正在巡检
      this.searchParam.findInspectExecutingPageParam.page = 1
      this.searchParam.findInspectExecutingPageParam.hospitalId = null
      this.searchParam.findInspectExecutingPageParam.status = null
      //  正在保养
      this.searchParam.findMaintainExecutingPageParam.page = 1
      this.searchParam.findMaintainExecutingPageParam.hospitalId = null
      this.searchParam.findMaintainExecutingPageParam.status = null
      // 右屏拆线图
      this.searchParam.findEquInspectPageParam.page = 1
      this.searchParam.findMaintainPageParam.page = 1
      this.searchParam.findEquInspectPageParam.hospitalId = null
      this.searchParam.findEquInspectPageParam.createTimeBegin = null
      this.searchParam.findEquInspectPageParam.createTimeEnd = null
      this.searchParam.findMaintainPageParam.hospitalId = null
      this.searchParam.findMaintainPageParam.createTimeBegin = null
      this.searchParam.findMaintainPageParam.createTimeEnd = null

      // if (this.showData.isShow) {
      //   this.showData.isShow = false;
      // }
      // 判定左边是否已选择时间
      console.log(this.searchParam.startTime)
      console.log(this.searchParam.endTime)
      if (this.searchParam.startTime && this.searchParam.endTime) {
        console.log('有选择时间')
        dataParam.startTime = this.searchParam.startTime
        dataParam.endTime = this.searchParam.endTime
      } else {
        console.log('没有选择时间')
        dataParam.startTime = null
        dataParam.endTime = null
      }
      // 判定左边是否已选择医院
      if (this.searchParam.hospitalId) {
        console.log('有选择医院')
        dataParam.hospitalId = this.searchParam.hospitalId
      }

      if (type === 'repair') {
        // 维修
        console.log('repair', type, data)
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        dataParam.type = type
        // 柱状图
        if (data && data.componentSubType && data.componentSubType === 'bar') {
          console.log('柱状图带过来的参数', data)
          dataParam.hospitalId = data.hospitalId
          dataParam.departId = data.departId
        }
        switch (data) {
          case 'noSuccess':
            // 正在维修
            dataParam.paramStatus = data
            dataParam.status = data
            break
          case 'confirmed':
            dataParam.paramStatus = data
            dataParam.status = data
            break
          case 'cost':
            dataParam.paramStatus = data
            dataParam.status = data
            break
          case 'allRepair':
            dataParam.paramStatus = data
            dataParam.status = null
            break
          default:
            dataParam.paramStatus = null
            dataParam.status = null
        }

        console.log(dataParam)
        this.showData.hospitalId = dataParam.hospitalId || null
        this.showData.departId = dataParam.departId || null
        this.searchParam.pageRepairParam.status = dataParam.status || null
        this.showData.currentStatus = dataParam.paramStatus || null
        this.searchParam.pageRepairParam.hospitalId = dataParam.hospitalId || null
        this.searchParam.pageRepairParam.departId = dataParam.departId || null
        this.searchParam.pageRepairParam.reportStartTime = dataParam.startTime || null
        this.searchParam.pageRepairParam.reportEndTime = dataParam.endTime || null
        this.searchParam.pageRepairParam.page = 1
        console.log('分页维修参数', this.showData)
        this.pageRepair()
      }
      // if( type === 'pageBeingRepaired' ){
      //   // 正在维修
      //   this.showData.type = type;
      //   this.showData.isShow = true;
      //   this.loading = true;
      //   this.pageBeingRepaired();
      // }
      if (type === 'equPage') {
        // 设备
        console.log(data)
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        if (data && data.indexOf('06-') != -1) {
          dataParam.paramStatus = data
          dataParam.status = data
        }
        if (data && data.indexOf('06-') != -1) {
          this.searchParam.getEquPageParam.medicalClassificationCode =
            dataParam.status
        } else {
          this.searchParam.getEquPageParam.medicalClassificationCode = null
        }

        switch (data) {
          case 'management':
            dataParam.paramStatus = data
            break
          case 'maintainWarranty':
            dataParam.paramStatus = data
            break
          case 'allEquStatus':
            dataParam.paramStatus = data
          default:
            console.log('data为空')
        }

        this.searchParam.getEquPageParam.hospitalId =
          dataParam.hospitalId || null
        this.searchParam.getEquPageParam.departId =
        dataParam.departId || null
        this.showData.hospitalId = dataParam.hospitalId || null
        this.showData.currentStatus = dataParam.paramStatus || null
        this.searchParam.getEquPageParam.page = 1
        this.getEquPage()
      }
      if (type === 'maintainPage') {
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        switch (data) {
          case 'unsuccessful':
            dataParam.paramStatus = data
            dataParam.status = data
            break
          case 'success':
            dataParam.paramStatus = data
            dataParam.status = data
            break
          default:
            dataParam.paramStatus = null
            dataParam.status = null
        }
        this.searchParam.findExecutingMaintainPageParam.createTimeBegin = dataParam.startTime || null
        this.searchParam.findExecutingMaintainPageParam.createTimeEnd = dataParam.endTime || null
        this.searchParam.findExecutingMaintainPageParam.hospitalId =
          dataParam.hospitalId || null
        this.searchParam.findExecutingMaintainPageParam.departId =
        dataParam.departId || null
        this.showData.hospitalId = dataParam.hospitalId || null

        this.searchParam.findExecutingMaintainPageParam.dataStatus =
          dataParam.status
        this.showData.currentStatus = dataParam.paramStatus
        this.searchParam.findExecutingMaintainPageParam.page = 1
        this.findExecutingMaintainPage()
      }
      if (type === 'inspectPage') {
        console.log('inspectPage')
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        switch (data) {
          case 'unsuccessful':
            dataParam.paramStatus = data
            dataParam.status = data
            break
          case 'success':
            dataParam.paramStatus = data
            dataParam.status = data
            break
          default:
            dataParam.paramStatus = null
            dataParam.status = null
        }
        this.searchParam.findExecutingInspectPageParam.createTimeBegin = dataParam.startTime || null
        this.searchParam.findExecutingInspectPageParam.createTimeEnd = dataParam.endTime || null
        this.searchParam.findExecutingInspectPageParam.hospitalId =
          dataParam.hospitalId || null
        this.showData.hospitalId = dataParam.hospitalId || null
        this.searchParam.findExecutingInspectPageParam.departId =
        dataParam.departId || null
        this.searchParam.findExecutingInspectPageParam.dataStatus =
          dataParam.status
        this.showData.currentStatus = dataParam.paramStatus
        this.searchParam.findExecutingInspectPageParam.page = 1
        this.findExecutingInspectPage()
      }
      if (type === 'findInspectExecutingPage') {
        console.log('findInspectExecutingPage')
        this.searchParam.findInspectExecutingPageParam.createTimeBegin = dataParam.startTime || null
        this.searchParam.findInspectExecutingPageParam.createTimeEnd = dataParam.endTime || null
        this.searchParam.findInspectExecutingPageParam.hospitalId =
          dataParam.hospitalId || null
        this.searchParam.findInspectExecutingPageParam.departId =
        dataParam.departId || null
        this.showData.hospitalId = dataParam.hospitalId || null
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        this.findInspectExecutingPage()
      }
      if (type === 'findMaintainExecutingPage') {
        console.log('findMaintainExecutingPage')
        this.searchParam.findMaintainExecutingPageParam.createTimeBegin = dataParam.startTime || null
        this.searchParam.findMaintainExecutingPageParam.createTimeEnd = dataParam.endTime || null
        this.searchParam.findMaintainExecutingPageParam.hospitalId =
          dataParam.hospitalId || null
        this.searchParam.findMaintainExecutingPageParam.departId =
        dataParam.departId || null
        this.showData.hospitalId = dataParam.hospitalId || null
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        this.findMaintainExecutingPage()
      }
      if (type.type === 'equInspectPage') {
        // 右屏拆线图 巡检
        console.log('右屏拆线图巡检', type)
        this.showData.type = type.type
        this.showData.isShow = true
        this.loading = true
        this.showData.date = type.date
        let date = new Date(type.date)
        if (type.date) {
          this.searchParam.findEquInspectPageParam.createTimeBegin =
            this.util.startMonth(date)
          this.searchParam.findEquInspectPageParam.createTimeEnd =
            this.util.endMonth(date)
        }
        this.searchParam.findEquInspectPageParam.hospitalId =
          dataParam.hospitalId || null
        this.showData.hospitalId = dataParam.hospitalId || null
        this.searchParam.findEquInspectPageParam.page = 1
        this.findEquInspectPage()
      }
      if (type.type === 'equMaintainPage') {
        // 右屏拆线图 保养
        console.log('右屏拆线图保养', type)
        this.showData.type = type.type
        this.showData.isShow = true
        this.loading = true
        this.showData.date = type.date
        let date = new Date(type.date)
        console.log(date)
        if (type.date) {
          this.searchParam.findMaintainPageParam.createTimeBegin =
            this.util.startMonth(date)
          this.searchParam.findMaintainPageParam.createTimeEnd =
            this.util.endMonth(date)
        }
        console.log(555555555555555555555555, this.util.startMonth(date))
        console.log(555555555555555555555555, this.searchParam.findMaintainPageParam)
        this.searchParam.findMaintainPageParam.hospitalId =
          dataParam.hospitalId || null
        this.showData.hospitalId = dataParam.hospitalId || null
        this.searchParam.findMaintainPageParam.page = 1
        this.findMaintainPage()
      }

      if (
        type === 'meteringPage' ||
        type === 'meteringPage-imperative' ||
        type === 'meteringPage-non_imperative'
      ) {
        // 计量
        switch (data) {
          case 'non_imperative':
            dataParam.paramStatus = data
            dataParam.status = data
            break
          case 'imperative':
            dataParam.paramStatus = data
            dataParam.status = data
            break
          default:
            dataParam.paramStatus = null
            dataParam.status = null
        }
        this.searchParam.getEquPageParam.measureType = dataParam.status
        this.showData.currentStatus = dataParam.paramStatus
        this.searchParam.getEquPageParam.departId =
          dataParam.departId || null
        this.searchParam.getEquPageParam.hospitalId =
          dataParam.hospitalId || null
        this.showData.hospitalId = dataParam.hospitalId || null
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        this.searchParam.getEquPageParam.page = 1
        this.getEquPage()
      }
      if (type === 'equPageValue') {
        // 设备价值
        console.log(data)
        if (data) {
          this.searchParam.getEquPageParam.purchaseMoneySearch = data
          this.showData.currentStatus = data
        } else {
          this.showData.currentStatus = null
          this.searchParam.getEquPageParam.purchaseMoneySearch = null
        }
        this.searchParam.getEquPageParam.departId =
          dataParam.departId || null
        this.searchParam.getEquPageParam.hospitalId =
          dataParam.hospitalId || null
        this.showData.hospitalId = dataParam.hospitalId || null
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        this.searchParam.getEquPageParam.page = 1
        this.getEquPage()
      }
      if (type === 'maintenanceType') {
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        if (data) {
          dataParam.paramStatus = data
          this.searchParam.getEquPageParam.hospitalId =
            dataParam.hospitalId || null
          this.showData.hospitalId = dataParam.hospitalId || null
          this.showData.currentStatus = dataParam.paramStatus || null
          this.searchParam.getEquPageParam.warrantyStatus =
            dataParam.paramStatus || null
          this.searchParam.getEquPageParam.page = 1
          this.getEquPage()
        }
      }
      if (type === 'ranking') {
        this.showData.type = type
        this.showData.isShow = true
        this.loading = true
        dataParam.hospitalId = data
        if (dataParam.hospitalId) {
          this.searchParam.selectEngineerRankingByPage.hospitalId = dataParam.hospitalId || null
        }
        this.showData.hospitalId = dataParam.hospitalId || null
        this.showData.currentStatus = dataParam.paramStatus || null
        this.selectEngineerRankingByPage()
      }
    },
    acceptInfoData (data) {
      console.log('分页全局信息------------', data)
      if (data) {
        //
        this.loading = false
        if (data.hospitalDtoList && data.hospitalDtoList.length > 0) {
          let obj = [
            {
              hospitalName: '所有医院',
              hospitalId: null
            }
          ]
          this.hospitalList = [...obj, ...data.hospitalDtoList]
        }
        if (data.enumsData) {
          // 枚举
          this.allEnumsData = data.enumsData.dataMap
          console.log('allEnumsData', this.allEnumsData)
          this.EquMaintainStatusList = this.allEnumsData.EquMaintainStatus //  保养
          this.MeasureTypeList = this.allEnumsData.MeasureType // 计量
          this.EquMaintainWarrantyStatusList =
            this.allEnumsData.EquMaintainWarrantyStatus // 保修
          this.EquInspectStatusList = this.allEnumsData.EquInspectStatus // 巡检
        }
        if (
          data.hospitalManagementTypeDTOList &&
          data.hospitalManagementTypeDTOList.length > 0
        ) {
          // 医院管理类型 选择医院后才赋值
          console.log('医院管理类型', data.hospitalManagementTypeDTOList)
          let all = [{
            typeName: '全部类型',
            typeId: null
          }]
          this.managementTypeList = [...all, ...data.hospitalManagementTypeDTOList]
        }

        if (data.equInspectDtoList && data.equInspectDtoList.records) {
          console.log('----成功取到巡检查询设备----')
          this.pages.total = data.equInspectDtoList.total
          this.pages.current = data.equInspectDtoList.current
          this.pages.pages = data.equInspectDtoList.pages
          this.pages.size = data.equInspectDtoList.size
          this.showData.dataList = data.equInspectDtoList.records.map(
            (item) => {
              if (item.status) {
                item.status = this.EquInspectStatus(item.status)
              }
              if (item.createTime) {
                item.createTime = util.formatDate2(item.createTime)
              }
              if (item.closeTime) {
                item.closeTime = util.formatDate2(item.closeTime)
              }

              return item
            }
          )
        }
        if (data.equMaintainDtoList && data.equMaintainDtoList.records) {
          console.log('----成功取到保养查询设备----')
          this.pages.total = data.equMaintainDtoList.total
          this.pages.current = data.equMaintainDtoList.current
          this.pages.pages = data.equMaintainDtoList.pages
          this.pages.size = data.equMaintainDtoList.size
          this.showData.dataList = data.equMaintainDtoList.records.map(
            (item) => {
              if (item.status) {
                item.status = this.EquMaintainStatus(item.status)
              }
              if (item.measureType) {
                item.measureType = this.MeasureType(item.measureType)
              }
              if (item.warrantyStatus) {
                item.warrantyStatus = this.EquMaintainWarrantyStatus(
                  item.warrantyStatus
                )
              }
              if (item.maintainDate) {
                item.maintainDate = util.formatDate2(item.maintainDate)
              }
              return item
            }
          )
        }
        if (data.equDtoList && data.equDtoList.records) {
          console.log('----成功取到分页查询设备----')
          this.pages.total = data.equDtoList.total
          this.pages.current = data.equDtoList.current
          this.pages.pages = data.equDtoList.pages
          this.pages.size = data.equDtoList.size

          this.equMaintainWarrantyStatusList =
            this.allEnumsData.EquMaintainWarrantyStatus // 保修类型
          this.showData.dataList = data.equDtoList.records.map((item) => {
            if (item.equMaintenanceDTO.warrantyStatus) {
              item.equMaintenanceDTO.warrantyStatus =
                allStatus.EquMaintainWarrantyStatus(
                  item.equMaintenanceDTO.warrantyStatus
                )
            }
            if (item.measureType) {
              item.measureType = allStatus.MeasureType(item.measureType)
            }
            if (item.createTime) {
              item.createTime = util.formatDate2(item.createTime)
            }
            if (item.status) {
              item.status = allStatus.EquStatus(item.status)
            }
            return item
          })
        }
        if (data.equRepairDtoList && data.equRepairDtoList.records) {
          console.log('----成功取到分页查询维修----')
          this.pages.total = data.equRepairDtoList.total
          this.pages.current = data.equRepairDtoList.current
          this.pages.pages = data.equRepairDtoList.pages
          this.pages.size = data.equRepairDtoList.size
          this.showData.dataList = data.equRepairDtoList.records.map((item) => {
            if (item.createTime) {
              item.createTime = util.formatDate2(item.createTime)
            }
            if (item.workHours) {
              item.workHours = util.formatHourNumToTimeStr(item.workHours)
            }
            if (item.closeDate) {
              item.closeDate = util.formatDate2(item.closeDate)
            }
            return item
          })
        }
        //  工程师排行
        if (data && data.engineerRankingDtoPageDto) {
          console.log('----成功取到工程师排行----')
          this.showData.dataList = data.engineerRankingDtoPageDto.records
        }
        //
        if (data && data.hospitalDepartmentDtos) {
          console.log('----成功取到当前医院的科室----')
          let all = [{
            departName: '全部科室',
            departId: null
          }]
          this.departList = [...all, ...data.hospitalDepartmentDtos]
          this.isDepartment = true
        }
      }
    },
    // 关闭中间弹窗
    Hide (e) {
      console.log(e)
      this.showData.isShow = false
    },
    // 改变页数size
    getSizePages (e) {
      console.log('改变页数size', e)
      if (e.type === 'repair') {
        this.searchParam.pageRepairParam.size = e.size
        this.loading = true
        this.pageRepair()
      } else if (e.type === 'equPage') {
        this.searchParam.getEquPageParam.size = e.size
        this.loading = true
        this.getEquPage()
      } else if (e.type === 'maintainPage') {
        this.searchParam.findExecutingMaintainPageParam.size = e.size
        this.loading = true
        this.findExecutingMaintainPage()
      } else if (e.type === 'inspectPage') {
        this.searchParam.findExecutingInspectPageParam.size = e.size
        this.loading = true
        this.findExecutingInspectPage()
      } else if (e.type === 'findInspectExecutingPage') {
        this.searchParam.findInspectExecutingPageParam.size = e.size
        this.loading = true
        this.findInspectExecutingPage()
      } else if (e.type === 'findMaintainExecutingPage') {
        this.searchParam.findMaintainExecutingPageParam.size = e.size
        this.loading = true
        this.findMaintainExecutingPage()
      } else if (e.type === 'equInspectPage') {
        this.searchParam.findEquInspectPageParam.size = e.size
        this.loading = true
        this.findEquInspectPage()
      }
    },
    // 选择页数
    getPages (e) {
      console.log('选择页数', e)
      if (e.type === 'repair') {
        this.searchParam.pageRepairParam.page = e.page
        this.loading = true
        this.pageRepair()
      } else if (
        e.type === 'equPage' ||
        e.type === 'meteringPage-imperative' ||
        e.type === 'meteringPage-non_imperative' ||
        e.type === 'meteringPage'
      ) {
        this.searchParam.getEquPageParam.page = e.page
        this.loading = true
        this.getEquPage()
      } else if (e.type === 'maintainPage') {
        this.searchParam.findExecutingMaintainPageParam.page = e.page
        this.loading = true
        this.findExecutingMaintainPage()
      } else if (e.type === 'inspectPage') {
        this.searchParam.findExecutingInspectPageParam.page = e.page
        this.loading = true
        this.findExecutingInspectPage()
      } else if (e.type === 'findInspectExecutingPage') {
        this.searchParam.findInspectExecutingPageParam.page = e.page
        this.loading = true
        this.findInspectExecutingPage()
      } else if (e.type === 'findMaintainExecutingPage') {
        this.searchParam.findMaintainExecutingPageParam.page = e.page
        this.loading = true
        this.findMaintainExecutingPage()
      } else if (e.type === 'equInspectPage') {
        this.searchParam.findEquInspectPageParam.page = e.page
        this.loading = true
        this.findEquInspectPage()
      } else if (e.type === 'equMaintainPage') {
        this.searchParam.findMaintainPageParam.page = e.page
        this.loading = true
        this.findEquInspectPage()
      } else if (e.type === 'maintenanceType') {
        this.searchParam.getEquPageParam.page = e.page
        this.loading = true
        this.findEquInspectPage()
      } else if (e.type === 'equPageValue') {
        this.searchParam.getEquPageParam.page = e.page
        this.loading = true
        this.getEquPage()
      }
    },
    // 筛选分页查询
    getHospitalPagesDate (e) {
      console.log('筛选分页查询', e)
      // 清空页数
      this.pages.pages = 1
      this.pages.size = 20
      this.showData.dataList = []
      let endTime = ''
      let startTime = ''
      if (this.searchParam.endTime && this.searchParam.startTime) {
        // 左侧已选择时间
        startTime = this.searchParam.startTime
        endTime = this.searchParam.endTime
      }

      if (e.type === 'repair') {
        this.searchParam.pageRepairParam.hospitalId = e.hospitalId || null
        this.searchParam.pageRepairParam.departId = e.departId || null
        this.searchParam.pageRepairParam.status = e.status || null // 工单状态
        this.searchParam.pageRepairParam.reportEndTime = endTime || null
        this.searchParam.pageRepairParam.reportStartTime = startTime || null // 选择的时间
        this.searchParam.pageRepairParam.page = 1
        this.pageRepair()
      } else if (e.type === 'equPage') {
        this.searchParam.getEquPageParam.hospitalId = e.hospitalId || null
        this.searchParam.getEquPageParam.departId = e.departId || null
        this.searchParam.getEquPageParam.typeId = e.managementType || null
        this.searchParam.getEquPageParam.medicalClassificationCode =
          e.category || null
        this.hospitalId = e.hospitalId || null
        this.loading = true
        console.log('getHospitalManagementTypeList', this.searchParam)
        this.getHospitalManagementTypeList()
        this.getEquPage()
      } else if (e.type === 'maintainPage') {
        this.searchParam.findExecutingMaintainPageParam.hospitalId =
          e.hospitalId || null
        this.searchParam.findExecutingMaintainPageParam.departId =
          e.departId || null
        this.searchParam.findExecutingMaintainPageParam.dataStatus =
          e.ExecutingMaintainStatus || null
        this.loading = true
        this.findExecutingMaintainPage()
      } else if (e.type === 'inspectPage') {
        // 巡检
        this.searchParam.findExecutingInspectPageParam.hospitalId =
          e.hospitalId
        this.searchParam.findExecutingInspectPageParam.departId =
          e.departId || null
        this.searchParam.findExecutingInspectPageParam.dataStatus =
          e.inspectStatus
        this.loading = true
        this.findExecutingInspectPage()
      } else if (e.type === 'findInspectExecutingPage') {
        // 正在巡检
        this.searchParam.findInspectExecutingPageParam.hospitalId =
          e.hospitalId
        this.searchParam.findInspectExecutingPageParam.departId =
          e.departId || null
        this.searchParam.findInspectExecutingPageParam.status =
          e.inspectExecutingStatus
        this.loading = true
        this.findInspectExecutingPage()
      } else if (e.type === 'findMaintainExecutingPage') {
        // 正在保养
        this.searchParam.findMaintainExecutingPageParam.hospitalId =
          e.hospitalId
        this.searchParam.findMaintainExecutingPageParam.departId =
          e.departId
        this.searchParam.findMaintainExecutingPageParam.status =
          e.maintainExecutingStatus
        this.loading = true
        this.findMaintainExecutingPage()
      } else if (e.type === 'equInspectPage') {
        // 右屏拆线图
        this.searchParam.findEquInspectPageParam.hospitalId = e.hospitalId
        this.searchParam.findEquInspectPageParam.createTimeBegin = e.startMonth
        this.searchParam.findEquInspectPageParam.createTimeEnd = e.endMonth
        this.loading = true
        this.findEquInspectPage()
      } else if (e.type === 'equMaintainPage') {
        // 右屏拆线图
        this.searchParam.findMaintainPageParam.hospitalId = e.hospitalId
        this.searchParam.findMaintainPageParam.createTimeBegin = e.startMonth
        this.searchParam.findMaintainPageParam.createTimeEnd = e.endMonth
        this.loading = true
        this.findMaintainPage()
      } else if (
        e.type === 'meteringPage-imperative' ||
        e.type === 'meteringPage-non_imperative' ||
        e.type === 'meteringPage'
      ) {
        // 计量
        this.searchParam.getEquPageParam.measureType = e.meteringStatus
        this.searchParam.getEquPageParam.departId =
          e.departId || null
        this.loading = true
        this.getEquPage()
      } else if (e.type === 'equPageValue') {
        // 设备价值
        this.searchParam.getEquPageParam.hospitalId = e.hospitalId
        this.searchParam.getEquPageParam.departId =
          e.departId || null
        this.searchParam.getEquPageParam.purchaseMoneySearch = e.equValue
        this.loading = true
        this.getEquPage()
      } else if (e.type === 'maintenanceType') {
        this.searchParam.getEquPageParam.hospitalId = e.hospitalId || null
        this.searchParam.getEquPageParam.departId =
          e.departId || null
        this.searchParam.getEquPageParam.warrantyStatus =
          e.EquMaintainWarrantyStatus || null
        this.hospitalId = e.hospitalId || null
        this.loading = true
        this.getHospitalManagementTypeList()
        this.getEquPage()
      } else if (e.type === 'ranking') {
        // 工程师工作排行
        console.log('工程师工作排行')
        // this.showData.hospitalId = dataParam.hospitalId || null;
        // this.showData.currentStatus = dataParam.paramStatus || null;
        this.searchParam.selectEngineerRankingByPage.departId =
          e.departId || null
        this.searchParam.selectEngineerRankingByPage.hospitalId = e.hospitalId || null
        this.loading = true
        this.selectEngineerRankingByPage()
      }
    },

    // getDepartmentList(data){
    //   console.log('查询科室----------',data)
    // },
    acceptUsersData (data) {
      console.log('用户信息----------', data)
      if (data && data.total) {
        this.users.total = data.total
      }
    },

    acceptEquData (data) {
      console.log('设备信息----------', data)
      if (data.equMaintenanceTotalDTO) {
        this.equMaintenanceTotalDTO = data.equMaintenanceTotalDTO
        // 对象转数组，想要转成什么字段根据需求
        let list = this.util.fmObjToArr(this.equMaintenanceTotalDTO)

        let isList = list.map((item) => {
          switch (item.label) {
            case 'fullAndManMadeTotal':
              item.label = 'full_and_man_made'
              item.name = '全保&技术保'
              break
            case 'noneTotal':
              item.label = 'none'
              item.name = '无保'
              break
            case 'originalArtificialTotal':
              item.label = 'original_artificial'
              item.name = '原厂人工保'
              break
            case 'manMadeTotal':
              item.label = 'man_made'
              item.name = '技术保'
              break
            case 'plantFullTotal':
              item.label = 'plant_full'
              item.name = '原厂保'
              break
            case 'selfInsuranceTotal':
              item.label = 'three_insured'
              item.name = '自保'
              break
            case 'threeInsuredTotal':
              item.label = 'three_insured'
              item.name = '三方在保'
              break
            case 'warrantyPeriodTotal':
              item.label = 'warranty_period'
              item.name = '安装质保期'
              break
          }
          return item
        })
        //  删除设备总数和全保设备的对象s
        isList = this.util.arrRemoveObj(isList, isList[0])
        this.maintenanceList = isList.map((item) => item.label)
        this.maintenanceTypeList = this.util.arrRemoveObj(isList, isList[1])
        console.log(this.maintenanceTypeList)
      }
      if (data.equMedicalClassificationTotalDTO) {
        this.intactRateList = []
        let equDataTotal = data.equMedicalClassificationTotalDTO
        // 卡片要的数据
        this.categoryEquTotal.cRTotal = Number(equDataTotal.cRTotal) + 50
        this.categoryEquTotal.cTTotal = Number(equDataTotal.cTTotal) + 50
        this.categoryEquTotal.dRTotal = Number(equDataTotal.dRTotal) + 50
        this.categoryEquTotal.dSATotal = Number(equDataTotal.dSATotal) + 50
        this.categoryEquTotal.mRTotal = Number(equDataTotal.mRTotal) + 50
        this.categoryEquTotal.mRITotal = Number(equDataTotal.mRITotal) + 50
        // 转成百分比
        this.intactRate.allEqu = this.util.percentage(
          equDataTotal.allTotal,
          equDataTotal.repairTotal
        )
        this.intactRate.cREqu = this.util.percentage(
          equDataTotal.cRTotal,
          equDataTotal.cRRepairTotal
        )
        this.intactRate.cTEqu = this.util.percentage(
          equDataTotal.cTTotal,
          equDataTotal.cTRepairTotal
        )
        this.intactRate.dRRepairEqu = this.util.percentage(
          equDataTotal.dRTotal,
          equDataTotal.dRRepairTotal
        )
        this.intactRate.dSARepairEqu = this.util.percentage(
          equDataTotal.dSATotal,
          equDataTotal.dSARepairTotal
        )
        this.intactRate.mRRepairEqu = this.util.percentage(
          // equDataTotal.mRTotal,
          // equDataTotal.mRRepairTotal
          equDataTotal.mRITotal,
          equDataTotal.mRIRepairTotal
        
        )
        this.intactRate.mRIEqu = this.util.percentage(
          equDataTotal.mRITotal,
          equDataTotal.mRIRepairTotal
        )
        console.log(9999, this.intactRate)
        // 转成数组 后会在组件内再转成二维数组
        for (const key in this.intactRate) {
          if (Object.hasOwnProperty.call(this.intactRate, key)) {
            switch (key) {
              case 'allEqu':
                this.intactRateList.push({
                  name: '所有设备',
                  value: Number(this.intactRate[key])
                })
                break
              case 'cREqu':
                this.intactRateList.push({
                  name: '彩超品类',
                  // name: 'CR品类',
                  value: Number(this.intactRate[key])
                })
                break
              case 'cTEqu':
                this.intactRateList.push({
                  name: 'CT品类',
                  value: Number(this.intactRate[key])
                })
                break
              case 'dRRepairEqu':
                this.intactRateList.push({
                  name: 'DR品类',
                  value: Number(this.intactRate[key])
                })
                break
              case 'dSARepairEqu':
                this.intactRateList.push({
                  name: 'DSA品类',
                  value: Number(this.intactRate[key])
                })
                break
              case 'mRRepairEqu':
                this.intactRateList.push({
                  name: 'MD品类', 
                  value: Number(this.intactRate[key])
                })
                break
              case 'mRIEqu':
                this.intactRateList.push({
                  name: 'MRI品类',
                  value: Number(this.intactRate[key]) || 0
                })
                break
              default:
                break
            }
          }
        }
      }
      if (data.mangementTypeTotalDTO) {
        this.mangementTypeTotalDTO = data.mangementTypeTotalDTO
        // 转成百分比
        console.log('intactRate', this.intactRate)
        let dataDTO = this.mangementTypeTotalDTO
        this.intactRate.firstAidTotal = this.util.percentage(
          dataDTO.firstAidTotal,
          dataDTO.firstAidRepairTotal
        )
        this.intactRate.implantTotal = this.util.percentage(
          dataDTO.implantTotal,
          dataDTO.implantRepairTotal
        )
        this.intactRate.largeMedicalEquTotal = this.util.percentage(
          dataDTO.largeMedicalEquTotal,
          dataDTO.largeMedicalEquRepairTotal
        )
        this.intactRate.lifeSupportTotal = this.util.percentage(
          dataDTO.lifeSupportTotal,
          dataDTO.lifeSupportRepairTotal
        )
        this.intactRate.radiationTotal = this.util.percentage(
          dataDTO.radiationTotal,
          dataDTO.radiationRepairTotal
        )
        this.intactRate.sterilizeTotal = this.util.percentage(
          dataDTO.sterilizeTotal,
          dataDTO.sterilizeRepairTotal
        )
        console.log('intactRate', this.intactRate)
        // 转成数组 后会在组件内再转成二维数组
        for (const key in this.intactRate) {
          if (Object.hasOwnProperty.call(this.intactRate, key)) {
            switch (key) {
              case 'firstAidTotal':
                this.intactRateList.push({
                  name: '急救类',
                  value: Number(this.intactRate[key])
                })
                break
              case 'implantTotal':
                this.intactRateList.push({
                  name: '生命支持类',
                  value: Number(this.intactRate[key])
                })
                break
              case 'largeMedicalEquTotal':
                this.intactRateList.push({
                  name: '植入类',
                  value: Number(this.intactRate[key])
                })
                break
              case 'lifeSupportTotal':
                this.intactRateList.push({
                  name: '灭菌类',
                  value: Number(this.intactRate[key])
                })
                break
              case 'radiationTotal':
                this.intactRateList.push({
                  name: '辐射类',
                  value: Number(this.intactRate[key])
                })
                break
              case 'sterilizeTotal':
                this.intactRateList.push({
                  name: '大型医用类',
                  value: Number(this.intactRate[key])
                })
                break
              default:
                break
            }
          }
        }
        console.log('设备类', this.intactRateList)
      }
    },
    // 选择品类和设备类型
    getType (e) {
      console.log('选择品类和设备类型', e)
      this.getShow(e.type, e.status)
    },
    acceptRepairData (data) {
      console.log('维修信息----------', data)
      if (data && data.repairNumDto) {
        if (data.repairNumDto) {
          // 平台维修总量
          this.allTotal = data.repairNumDto.allTotal
          this.costTotal = data.repairNumDto.costTotal || 0 // 平台维修等待关单
          this.confirmedTotal = data.repairNumDto.confirmedTotal || 0 // 平台维修等待验收
        }
      }
      // 维修柱状图
      if (data && data.statisticsDtoList) {
        if (data && data.statisticsDtoList.length) {
          this.barXAxis = data.statisticsDtoList.map((item) => item.name)
          this.barSeriesList = data.statisticsDtoList
		  if (this.searchParam.hospitalId) {
			  // 已经选择了医院，那么返回的是科室
            this.isDepartment = true
		  } else {
			  this.isDepartment = false
		  }
        } else {
          this.barXAxis = ['无', '无', '无']
          this.barSeriesList = [0, 0, 0]
        }
        this.updateChart()
      }

      // 平均维修工时
      if (data && data.avgDurationDto) {
        this.repairAvgDuration =
          data.avgDurationDto.repairAvgDuration.toFixed(2)
        this.responseAvgDuration =
          data.avgDurationDto.responseAvgDuration.toFixed(2)
      }
    },
    acceptStatisticsData (data) {
      console.log('统计信息----------', data)
      if (data.engineerRankingDto) {
        this.engineerRankingDto = data.engineerRankingDto
      }
    },
    startInterval () {
      // 柱状图定时向左移动
      if (this.timdId) {
        clearInterval(this.timdId)
      }
      this.timdId = setInterval(() => {
        this.startValue++
        this.endValue++
        if (this.barXAxis && this.endValue > this.barXAxis.length - 1) {
          this.startValue = 0
          this.endValue = 5
        }
        this.updateChart()
      }, 3000)
    },
    drawLine () {
      // 初始化柱状图echarts实例
      let _this = this
      this.chartInstance = this.$echarts.init(
        document.getElementById('histogram')
      )
      // 柱状图点击事

      this.chartInstance.on('click', function (params) {
        console.log('柱状图点击事', params)
        console.log('是否已经选择了医院', _this.isDepartment)
        let data = {
          type: 'repair',
          hospitalId: null,
          departId: null,
          componentSubType: params.componentSubType
        }
        if (_this.isDepartment) { // 医院/科室--ID赋值
          console.log('医院/科室--ID赋值')
          data.departId = params.data.id
          data.hospitalId = _this.searchParam.hospitalId
        } else {
          data.departId = null
          data.hospitalId = params.data.id
        }
        console.log('柱状图组装的参数', data)
        _this.getShow('repair', data)
      })
      // 柱状图初始化配置
      const initOption = {
        grid: {
          // 整体调位置
          top: 50,
          left: 0,
          right: '4%',
          bottom: -20,
          containLabel: true
        },
        tooltip: {
          show: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            show: true,
            rotate: -35,
            color: '#7292D8',
            fontSize: 10,
            margin: 25, // 刻度标签与轴线之间的距离
            padding: [0, 0, 0, -30]
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#7292D8',
            fontSize: 10
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#112553'],
              width: 0.8,
              type: 'solid'
            }
          }
        },
        barWidth: '15'
      }
      this.chartInstance.setOption(initOption)
    },
    updateChart () {
      // 处理图表数据
      const dataOption = {
        dataZoom: {
          show: false,
          startValue: this.startValue,
          endValue: this.endValue
        },
        xAxis: {
          data: this.barXAxis
        },
        legend: {
          data: ['维修工单'],
          itemWidth: 12,
          itemHeight: 8,
          icon: 'rect',
          left: '80%',
          right: 0,
          top: 0,
          bottom: 0,
          textStyle: {
            color: '#ffffff'
          },
          itemStyle: {
            color: 'rgba(12, 247, 189, 1)'
          }
        },
        yAxis: {
          type: 'value'
        },
        // barSeries
        series: [
          {
            name: '维修工单',
            type: 'bar',
            data: this.barSeriesList,
            label: {
              width: 20,
              overflow: 'break',
              show: true,
              position: 'top',
              width: 150,
              color: '#0CEDB7'
            },
            itemStyle: {
              color: (arg) => {
                return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(12, 247, 189, 1)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(12, 247, 189, 0)'
                  }
                ])
              }
            }
          }
        ]
      }
      this.chartInstance.setOption(dataOption)
      this.chartInstance.on('mouseover', () => {
        clearInterval(this.timdId)
      })
      this.chartInstance.on('mouseout', () => {
        this.startInterval()
      })
    },
    update () {
      let data = option.series[0].data
      for (var i = 0; i < data.length; ++i) {
        if (Math.random() > 0.9) {
          data[i] += Math.round(Math.random() * 2000)
        } else {
          data[i] += Math.round(Math.random() * 200)
        }
      }
      myChart.setOption(option)
    },
    // 获取已选择保修类型
    getMaintenance (e) {
      console.log(e)
      this.getShow('maintenanceType', e.label)
    },
    EquMaintainStatus (status) {
      // 保养状态枚举
      for (let item of this.EquMaintainStatusList) {
        if (item.name === status) {
          return item.value
        }
      }
      return ''
    },

    MeasureType (status) {
      // 计量状态枚举
      for (let item of this.MeasureTypeList) {
        if (item.name === status) {
          return item.value
        }
      }
      return ''
    },
    EquMaintainWarrantyStatus (status) {
      // 保修状态枚举
      for (let item of this.EquMaintainWarrantyStatusList) {
        if (item.name == status) {
          return item.value
        }
      }
      return ''
    },
    EquInspectStatus (status) {
      // 巡检状态枚举
      for (let item of this.EquInspectStatusList) {
        if (item.name == status) {
          return item.value
        }
      }
      return ''
    }
  },
  computed: {}
}
</script>
<style>
@import "../style/common.css";
.flip {
  position: relative;
  transition: 15.6s;
  transform-style: preserve-3d;
}
.front,
.back {
  position: absolute;
  top: 0px;
  left: 0px;
  backface-visibility: hidden;
}
.front {
  z-index: 2;
}
.back {
  transform: rotateY(-180deg);
}
.container:hover .flip {
  transform: rotateY(180deg);
}

.left-index {
  position: relative;
}
#left {
  width: 1920px;
  height: 1080px;
  background-image: url("../assets/dx-bg.png");
  background-repeat: no-repeat;
}
.left-top-type {
  position: relative;
}
.left-date {
  width: 482px;
  height: 96px;
  background-image: url("../assets/left-date.png");
  background-repeat: no-repeat;
}
.date {
  height: 96px;
  line-height: 135px;
  font-size: 24px;
  color: #a2c6f9;
  display: flex;
  text-align: center;
}
.date-div {
  width: 482px;
  font-family: "DIN-BOLD";
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}
.icon19 {
  width: 20px;
  height: 20px;
  margin: auto 0;
  margin-right: 11px;
}
.time {
  margin-left: 25px;
}
.center {
  position: absolute;
  left: 154px;
  top: 0;
}
.center-logo {
  width: 1766px;
  height: 100px;
  background-image: url("../assets/center-logo.png");
  background-repeat: no-repeat;
}
.center-text {
  font-size: 42px;
  height: 100px;
  line-height: 100px;
  /* padding-left: 925px; */
  font-weight: bold;
  letter-spacing: 10px;
  background-image: linear-gradient(#e2ebff, #6da7ff);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.padd {
  margin-left: 780px;
  width: 700px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.icon8 {
  width: 40px;
  height: 1px;
}
.icon9 {
  width: 40px;
  height: 1px;
}
.leftmost {
  padding-left: 17px;
  float: left;
}
/* 平台维修量 */
#platformRepairQuantity {
  width: 429px;
  height: 244px;
  background-image: url("../assets/bg05.png");
  background-repeat: no-repeat;
  margin-top: 22px;
  padding: 15px 22px;
  box-sizing: border-box;
  position: relative;
}
.dynamicDigital {
  height: 66px;
  line-height: 66px;
  margin: 25px 0px 0 20px;
}
.text-single {
  margin-left: 10px;
  height: 66px;
  line-height: 110px;
}
.wait {
  margin-top: 28px;
  margin-left: 20px;
}
.wait-close-single {
  height: 55px;
}
.imgIcon01 {
  width: 42px;
  height: 55px;
  line-height: 85px;
  float: left;
}
.img-icon01 {
  width: 42px;
  height: 42px;
}
.wait-text {
  float: left;
  margin-left: 15px;
}
.text-red {
  color: #f83b44;
  font-size: 24px;
}
.text-LG {
  color: #41c476;
  font-size: 24px;
}
/* 平台设备好评率 */
#praise {
  width: 429px;
  height: 324px;
  background-image: url("../assets/bg09.png");
  background-repeat: no-repeat;
  margin-top: 25px;
  padding: 15px 22px 5px;
  box-sizing: border-box;
  position: relative;
}
.equ-praise {
  width: 380px;
  height: 280px;
  display: flex;
  align-items: center;
}
.equ-praise > .bg-img {
  width: 380px;
  height: 264px;
  background-image: url("../assets/icon-07.png");
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  padding: 0 20px;
}
.E-public {
  /* float: left; */
  margin: 10px 0 5px;
}

/* 医院维修排行 */
#repairRanking {
  width: 429px;
  height: 324px;
  background-image: url("../assets/bg09.png");
  background-repeat: no-repeat;
  margin-top: 23px;
  padding: 15px 10px;
  box-sizing: border-box;
  position: relative;
}
.histogram {
  width: 409px;
  height: 280px;
}

/* 品类设备 */
.equ-number {
  float: left;
  margin: 22px 0 0 18px;
}
/* .bg-equ {
  width: 174px;
  height: 143px;
  background-image: url("../assets/bg00.png");
  background-repeat: no-repeat;
  box-sizing: border-box;
  margin-bottom: 16px;
  padding: 45px 0 0 18px;
}
.bg-equ > .equ-text {
  color: #00ffff;
  font-size: 34px;
  margin-bottom: 5px;
  letter-spacing: 2px;
} */
/* 中心 */
.center-equ-total {
  width: 1282px;
  height: 958px;
  /* background-color: turquoise; */
  float: left;
  position: relative;
}
.equ-total {
  position: relative;
  margin-left: 298px;
  margin-top: 55px;
  height: 692px;
  width: 692px;
  box-sizing: border-box;
}

.bg-equ-total {
  width: 692px;
  height: 692px;
  background-image: url("../assets/icon-04.png");
  background-repeat: no-repeat;
  background-position: center;
  animation: circleRoate 8s infinite linear;
  position: absolute;
  top: 0px;
  left: 0px;
}
.radar {
  width: 692px;
  height: 692px;
  background-image: url("../assets/circle.png");
  background-repeat: no-repeat;
  background-position: center;
  animation: radar 8s infinite linear;
  z-index: 9;
  position: absolute;
}
.circle3 {
  width: 355px;
  height: 480px;
  background-image: url("../assets/Inner-circle.png");
  background-repeat: no-repeat;
  background-size: 415px 361px;
  position: absolute;
  top: 110px;
  left: 164px;
  z-index: 11;
  text-align: center;
  box-sizing: border-box;
}
.total {
  margin: 145px 0 150px 10px;
  cursor: pointer;
}
.total-text {
  font-size: 40px;
  color: #ffffff;
  margin-bottom: 5px;
  font-family: "DIN-BOLD";
}
.total-title {
  font-size: 14px;
  color: #00ffff;
}
.bgDownH {
  padding-top: 10px;
  height: 30px;
}
.bgDown {
  width: 355px;
  height: 20px;
  background-image: url("../assets/icon-18.png");
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  position: relative;
  animation: bgDown 1.8s infinite;
  -webkit-animation: bgDown 1.8s infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
}
.processing {
  width: 320px;
  height: 60px;
  display: flex;
  justify-content: center;
  justify-content: space-between;
  margin: 0 22px;
}
.ls {
  font-size: 26px;
  color: #00ffff;
}
.ls > span {
  font-size: 16px;
}
/* 用户数量 */
.number-users-ico {
  position: absolute;
  top: 90px;
  left: -20px;
  width: 555px;
  height: 254px;
}
.us-bg-img {
  width: 276px;
  height: 254px;
  background-image: url("../assets/icon-11.png");
  background-repeat: no-repeat;
  position: relative;
}
.bg-icon10 {
  position: absolute;
  top: 30px;
  left: 30px;
}
.icon10 {
  width: 234px;
  height: 234px;
  position: relative;
  animation: Icon10 2s infinite;
  -webkit-animation: Icon10 2s infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
}
.icon14 {
  width: 28px;
  height: 33px;
  position: absolute;
  top: 44px;
  right: 25px;
}
.number-users {
  width: 165px;
  height: 109px;
  background-image: url("../assets/bg01.png");
  background-repeat: no-repeat;
  background-size: 276px 109px;
  background-position-y: -21px;
  position: absolute;
  top: -25px;
  left: 255px;
  box-sizing: border-box;
  text-align: center;
  padding-top: 10px;
}
.users-text {
  font-size: 28px;
  color: #ffffff;
  margin-bottom: 8px;
}
/* 平均维修工时  */
.repair-hours {
  width: 329px;
  height: 487px;
  box-sizing: border-box;
  position: absolute;
  top: 420px;
  left: 0px;
}
.repair-hours-img {
  width: 323px;
  height: 298px;
  background-image: url("../assets/icon-17.png");
  background-repeat: no-repeat;
  position: relative;
}
.bg-icon17 {
  position: absolute;
  top: 85px;
  left: 100px;
}
.icon17 {
  width: 175px;
  height: 189px;
  position: relative;
  animation: repairHoursImg 2.2s infinite;
  -webkit-animation: repairHoursImg 2.2s infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
}
.icon15 {
  width: 30px;
  height: 40px;
  position: absolute;
  top: 270px;
  right: 125px;
}
.repair-hours-text {
  width: 212px;
  height: 127px;
  background-image: url("../assets/bg03.png");
  background-repeat: no-repeat;
  background-size: 299px 149px;
  background-position-y: -22px;
  position: absolute;
  top: 315px;
  left: 75px;
  box-sizing: border-box;
  text-align: center;
  padding: 15px 0;
}
.response {
  color: #fff;
}
.mb10 {
  margin-bottom: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
.w56 {
  width: 56px;
  display: inline-block;
}
/* 全保设备 */
.full-insurance-equ {
  width: 329px;
  height: 487px;
  box-sizing: border-box;
  position: absolute;
  top: 50px;
  right: 0px;
}
.full-bg-img {
  width: 252px;
  height: 291px;
  background-image: url("../assets/icon-13.png");
  background-repeat: no-repeat;
  position: relative;
  /* animation:Icon12 2s infinite;
    animation-direction:alternate; */
}
.bg-icon12 {
  position: absolute;
  top: 105px;
  left: 50px;
}
.icon12 {
  width: 151px;
  height: 173px;
  position: relative;
  animation: Icon12 1.8s infinite;
  -webkit-animation: Icon12 1.8s infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
}
.icon16 {
  width: 30px;
  height: 45px;
  position: absolute;
  top: 290px;
  right: 80px;
}
.full-insurance {
  width: 162px;
  height: 229px;
  background-image: url("../assets/bg02.png");
  background-repeat: no-repeat;
  background-size: 276px 229px;
  background-position-y: -22px;
  position: absolute;
  top: 340px;
  left: 88px;
  box-sizing: border-box;
  text-align: center;
  padding: 15px 0px;
}
.warranty-type {
  width: 162px;
  height: 108px;
  overflow: hidden;
  overflow-y: scroll;
  cursor: pointer;
}
.full-insurance-text {
  margin-left: 18px;
  margin-bottom: 8px;
  color: #ffffff;
  text-align: initial;
  display: flex;
  align-items: center;
}
.full-insurance-text-name {
  width: 70px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.warranty-type::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  padding-right: 2px;
}
.warranty-type::-webkit-scrollbar-thumb {
  background: #a2c6f9;
  border-radius: 2px;
}
/* 中间弹窗 */
#middle {
  animation: fade-in;
  animation-duration: 4s;
  -webkit-animation: fade-in 1.5s;
}

.all-details {
  width: 1229px;
  height: 678px;
  position: absolute;
  top: 185px;
  left: 670px;
  z-index: 999;
  background-image: url("../assets/bg-details.png");
  background-repeat: no-repeat;
}
.typeNameClass {
  font-size: 32px;
}
/* .mlr43{
    margin-left: 40px;
} */
@keyframes fade-in {
  0% {
    opacity: 0;
  } /*初始状态 透明度为0*/
  40% {
    opacity: 0.8;
  } /*过渡状态 透明度为0*/
  100% {
    opacity: 1;
  } /*结束状态 透明度为1*/
}
@-webkit-keyframes fade-in {
  /*针对webkit内核*/
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
}

@keyframes circleRoate {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}
@keyframes radar {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes bgDown {
  from {
    bottom: 15px;
  }
  to {
    bottom: 0px;
  }
}

@keyframes Icon10 {
  from {
    bottom: 15px;
  }
  to {
    bottom: 0px;
  }
}
@keyframes repairHoursImg {
  from {
    bottom: 15px;
  }
  to {
    bottom: 0px;
  }
}
@keyframes Icon12 {
  from {
    bottom: 15px;
  }
  to {
    bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/left_index.vue